import SnackbarUtils from "views/components/SnackbarUtils";

class BaseService {
    handleError(error) {
        try {
            if (error.response.status == 0) {
                SnackbarUtils.error('Rede ou serviço temporariamente indisponível, tente novamente em instantes.');
            } else if (error.response.status == 401 && error.response.data.error === 'Token invalid') {
                SnackbarUtils.info('Sessão expirada, faça o login novamente.');
            } else {
                this.filterErrorHandle(error);
            }
        } catch (err) {
            SnackbarUtils.error('Rede ou serviço temporariamente indisponível, tente novamente em instantes.');
        } 
    }

    filterErrorHandle(error) {
        const status = error.response.status;

        if (status >= 100 && status <= 199) { //Informational
            SnackbarUtils.info(error.response.data.message);
        } else if (status >= 200 && status <= 299) { // Success
            SnackbarUtils.success(error.response.data.message);
        } else if (status >= 300 && status <= 399) { // Redirection
            SnackbarUtils.info(error.response.data.message);
        } else if (status === 400 || status === 422) { // Client Error - Warning
            SnackbarUtils.warning(error.response.data.message);
        } else if (status === 401) { // Unauthorized
            SnackbarUtils.warning(error.response.data.message);
        } else if (status >= 400 && status <= 499) { // Client Error - Error
            if (error.response.data.message) {
                SnackbarUtils.error(error.response.data.message);
            } else if (error.response.data.correlationId) {
                SnackbarUtils.error(error.response.data.correlationId);
            }
        } else if (status >= 500 && status <= 599) { // Server Error
            if (error.response.data.message === 'Ocorreu um erro ao listar promocoes.') {
                SnackbarUtils.info('Nenhuma Promoção encontrada!');
            } else {
                SnackbarUtils.warning(error.response.data.message);
            }
        }
    }
}

export default new BaseService();